import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslatorModule } from 'angular-translator';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    TranslatorModule,
    RouterModule
  ],
  declarations: [],
  exports: [],

})
export class NavbarModule {}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/navbar/navbar.module.ts